import { createApp } from 'vue';
import VueApexCharts from 'vue3-apexcharts';
import { createPinia } from 'pinia';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { App, getRouter, vuetifyOptions, type IConfiguration } from '@fondationcss/ui';
import { getCustomRoutes } from './routes';
import { menus } from './sidebar-items';

import 'vuetify/styles';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fondationcss/ui/dist/style.css';
import '@/styles.css';

const config = {
  AppName: 'Scheduler',
  SiteNameShort: 'Scheduler',
  SiteNameLong: 'Ordonnanceur du solveur de planification',
  LogoLine1: 'Ordonnanceur du solveur',
  LogoLine2: 'de planification',
  Copyright: 'Copyright © 2026',
  SidebarItems: [],
  // Sans cette orientation, les groupes d'une section sont rendus en rangée
  // horizontale et n'apparaissent jamais dans le rail latéral : la section
  // s'affichait en icône seule, sans ses quatre vues. C'est le réglage que
  // Parcours utilise.
  MenuGroupsOrientation: 'vertical',
  Menus: menus,
  EnableAccessRequestButton: false,

  // Identite visuelle reprise de Parcours (meme marque, meme bleu), surmontee
  // d'un badge « Scheduler » : le scheduler est un service de la famille
  // Parcours, pas un produit distinct.
  DefaultLayout: 'byrnu-red-app',
  ThemeColor: '#3460a8',
  Logo: '/images/scheduler.svg',
  SiteLogo: '/images/scheduler.svg',
  SiteLogoAlt: '/images/scheduler-alt.svg',
  HideLoginLogo: true,
} as IConfiguration;

const vuetify = createVuetify({ components, directives, ...vuetifyOptions });

const app = createApp(App);
app.provide('config', config);
app.use(vuetify);
app.component('font-awesome-icon', FontAwesomeIcon);
library.add(fas);
library.add(far);
app.use(createPinia());
// Meme bibliotheque de graphiques que frontend/ de Parcours : un seul choix
// pour toute la maison, et le patron de composants y est deja etabli.
app.use(VueApexCharts);
app.use(PerfectScrollbarPlugin);
app.use(getRouter(getCustomRoutes));
app.mount('#app');
